import React from 'react'

function CurrentVersion() {
  return (
    <div className='container-freeversion'>

<div className='title-version-container' >
<h1>Standar Versión</h1>
      </div>

     <div className="service-card-promotion">
     <h2 className="service-title">Standar Version ¡Proximamente!</h2>
     
                  <p className="service-price">$70 USD/mes</p>
                  <div className='container-free-title'>
                  {/* <p className='free-title-2'></p> */}
                  </div>
                  <ul className="service-benefits">
                    <li><strong>Base de datos</strong></li>
                    <li><strong>Limitacion ingreso de app</strong></li>
                    <li><strong>Registro</strong></li>
                    <li><strong>Control de mesas</strong></li>
                    <li><strong>Pedido de mesero</strong></li>
                    <li><strong>Soporte en linea</strong></li>
                    <li className="not-included">Registro de personal</li>
                    <li className="not-included">Blog para anuncio restaurante</li>
                    <li className="not-included">Ajustes avanzados</li>
                  </ul>
              </div>
                <div className='container-promotion-free'>
  <p>La **versión corriente** es la opción intermedia del producto completo, diseñada para ofrecer una manera económica de modernizar su restaurante. Con esta versión, su establecimiento contará con una base de datos propia y una versión en inglés para su menú, ideal si su restaurante tiene un alcance internacional.</p>

  <p>El proceso es sencillo: solo necesita escribirnos y responder algunas preguntas. Después, simplemente proporcione los nombres de los platos de su menú y una foto de cada uno para asegurarnos de usar la información de manera correcta en nuestra aplicación.</p>

  <p>Si desea adquirir la versión corriente, solo tiene que escribirnos a través de .</p>

</div>

    </div>
  )
}

export default CurrentVersion